import firebase from "datastore/database";

export async function update(uid, data, url) {
  return firebase
    .firestore()
    .collection(url)
    .doc(uid)
    .update(data);
}

export function add(data, url) {
  const doc = firebase
    .firestore()
    .collection(url)
    .doc();
  doc.set(data);
  return { uid: doc.id, ...data };
}

export async function deleteF(uid, url) {
  return firebase
    .firestore()
    .collection(url)
    .doc(uid)
    .delete();
}

export async function get(uid, url) {
  const doc = await firebase
    .firestore()
    .collection(url)
    .doc(uid)
    .get();

  if (!doc.exists) {
    return null;
  }

  return doc.data();
}
